import { ITeam } from "@/interfaces/teams/teams";
import { requestB2C } from "@/utils/request";
import POSConfigModule from "@/store/modules/pos-config";

/**
 * POST pair new team
 */
export async function postPairTeam(
  team: ITeam,
  bookingId: number,
  bookingToken: string
) {
  const response = await requestB2C({
    url: `/fba/group/${POSConfigModule.groupId}/booking/${bookingId}/team`,
    method: "post",
    data: {
      booking: bookingId,
      name: team.name,
      startDateTimeTz: team.startDateTime,
      endDateTimeTz: team.endDateTime,
      roomPlayers: team.roomPlayers,
      nfcTag: team.nfcTag,
      teamLevel: team.teamLevel,
    },
    params: {
      bookingToken,
    },
  });

  return response.data;
}

/**
 * PUT pair team
 */
export async function patchPairTeam(
  team: ITeam,
  bookingId: number,
  bookingToken: string
) {
  const response = await requestB2C({
    url: `/fba/group/${POSConfigModule.groupId}/booking/${bookingId}/team/${team.uuid}`,
    method: "patch",
    data: {
      name: team.name,
      roomPlayers: team.roomPlayers,
      nfcTag: team.nfcTag,
      teamLevel: team.teamLevel,
    },
    params: {
      bookingToken,
    },
  });

  return response.data;
}

/**
 * DELETE team
 * @param teamUuid
 * @param bookingId
 */
export async function deleteTeam(
  teamUuid: string,
  bookingId: number,
  bookingToken: string
) {
  const response = await requestB2C({
    url: `/fba/group/${POSConfigModule.groupId}/booking/${bookingId}/team/${teamUuid}`,
    method: "delete",
    params: {
      bookingToken,
    },
  });

  return response.data;
}
